import React, { useEffect, Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import CategoryForm from 'Component/DashboardQeza/Category/Form';
import { getCategory } from 'Services/Features/Category/Utils/categoryUtils';
import { setFormData, resetFormData } from 'Services/Features/Category/categorySlice';

const CategoryAdd = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const filters = useSelector(state => state.category.filters)
    const currentCategory = useSelector((state) => state.category.currentCategory);
    const [refetch, setRefetch] = useState(false);

    // console.log(currentCategory, 'currentCategory');
    useEffect(() => {
        window.scrollTo(0, 0);

        if (id && !currentCategory?.id) {
            // Buat filter untuk ambil data berdasarkan ID
            const newFilters = {
                ...filters,
                "filter[id]": id,
                page: 1,
            };

            // Fetch data dari API pakai ID
            dispatch(getCategory(newFilters)).then((response) => {
                if (response.payload && response.payload.data?.length > 0) {
                    const item = response.payload.data[0]; // Ambil item pertama (kalau ada)

                    // Simpan photos & banner ke state terpisah
                    dispatch(setFormData({ bannerLink: item.banner }));

                    // Buat objek baru tanpa photos & banner
                    const { banner, ...updatedItem } = item;

                    dispatch(setFormData({
                        ...updatedItem,
                    }));
                }
            });
        } else if (currentCategory?.id) {
            // Kalau nggak ada ID, tapi ada data di state, pakai yang ada
            dispatch(setFormData({
                ...currentCategory,
            }));
        } else {
            // Kalau nggak ada ID & data di state, reset form
            dispatch(resetFormData());
        }
    }, [id, refetch]);



    return (
        <Fragment>
            <Breadcrumbs parent="Kategori Perawatan" title={id ? 'Edit Kategori Perawatan' : 'Tambah Kategori'} />
            <CategoryForm label={id ? "" : "Kategori Baru"} setRefetch={setRefetch} />
        </Fragment>
    );
};
export default CategoryAdd;